// extracted by mini-css-extract-plugin
export default {"main":"Oba-z"};